<mat-dialog-content>
  <app-synto-document-list
    [screenName]="'DOCUMENTATION'"
    [entityType]="'PORTAL'"
    [entityId]="0"
    [isPublic]="true">
  </app-synto-document-list>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
  <button (click)="onCloseDialog()" class="eCase-dialog-negative-action-button"
          mat-raised-button>{{ 'close' | translate }}</button>
</mat-dialog-actions>



